import { type NotificaResponseDTO } from '@framework/api-client/api/backoffice/schemas/notificaResponseDTO.ts';
import { List } from 'antd';
import { type ListItemProps } from 'antd/lib/list/Item';
import styled from 'styled-components';

const ListItem = styled(List.Item)`
  &&& {
    padding-right: 4px;
    /* &.type-info {
      background-color: #e6f7ff;
    } */
    &.type-warning {
      background-color: #fff7e6;
    }
    .ant-list-item-action {
      margin-left: 0; // 14px;
      margin-inline-start: 0; // 48px;
    }
    .ant-list-item-action {
      li:last-child {
        padding-right: 0;
      }
    }
  }
`;

interface ListItemNotificationProps extends ListItemProps {
  type?: NotificaResponseDTO['tipo'];
}
/**
 * Singolo elemento stilizzato di una notifica
 * imposta il colore di sfondo in base al tipo
 */
export function ListItemNotification(props: ListItemNotificationProps) {
  const { type, ...othersProps } = props;

  return (
    <ListItem
      {...othersProps}
      className={type ? `type-${type.toLowerCase()}` : ''}
    />
  );
}
